var $ = require('jquery')

$(() => {
  const ga_send_url = document.getElementById("request-url").value
  const ga_label = document.getElementsByClassName("ga-label")[0].value
  const pc_device_name = document.getElementsByClassName("pc-device-name")[0].value
  const sp_device_name = document.getElementsByClassName("sp-device-name")[0].value

  function sendGaForPc () {
    ga("send", "event", "click", ga_send_url, pc_device_name + '_' + ga_label)
  }
  function sendGaForSp () {
    ga("send", "event", "click", ga_send_url, sp_device_name + '_' + ga_label)
  }

  $('.pc-ga-send-button').on('click', sendGaForPc)
  $('.sp-ga-send-button').on('click', sendGaForSp)
})
